import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { SmartFormInterFace, SmartSoftButton, SmartSoftForm } from "soft_digi";
import { SmartValid, ValidateFormNew } from "soft_digi/dist/services/smartValidationService";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showNotification } from "../../services/notifyService";
import { post } from "../../services/smartApiService";
// import { SmartValid } from "../../services/smartValidationService";;
import { DSC_URLS } from "../../api/DscUrls";
import { TASK_API_URLS } from "../../api/TaskApiUrls";

const initialValue = {
  dsc_empid: "",
  dsc_empname: "",
  dsc_type: {value:"",label:""},
}

interface childrenProps {
  dataIn?: any,
  loadTableData: () => void
}

const  DscForm: React.FC<childrenProps> = ({dataIn, loadTableData}) => {
  const [formData, setFormData] = useState<any>(initialValue);
  const { setLoading, closeModal} = useSiteContext();

  const navigate = useNavigate();

  useEffect(()=>{
    if(dataIn){
      let updatedForm = {
        id: dataIn?.ID,
        dsc_empid: dataIn?.dsc_empid,
        dsc_empname: dataIn?.dsc_empname,
        dsc_type: dataIn?.dsc_type,
      }
      setFormData(updatedForm)
    }
  },[])

  const handleSave = () => {
    if (!ValidateFormNew(formData,formElements)) return false;
    if(formData?.dsc_empid == "") return showNotification("error","Please Enter the Employee ID");  
    const task_fields = {
      dsc_type:formData?.dsc_type?.value
    }
    const payload = {
      "task_user_id":formData.dsc_empid,
      "task_user_name":formData.dsc_empname,
      "task_fields":JSON.stringify(task_fields),
      "task_created_portal":"SELF",      
    }
    const api = TASK_API_URLS.INSERT_DSC_TASK;
    const subscription = post(api,payload).subscribe((response) => {     
      navigate("/auth/dsc/register?token=" + response.data.data);
      closeModal();
    });
    return () => subscription.unsubscribe();
  };

  const validations = {
    dsc_empid: [ SmartValid.required("Required")],
    dsc_type: [ SmartValid.required("Required")],
    dsc_empname: [ SmartValid.required("Required")]
  };

  const formElements:SmartFormInterFace.SmartFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: "6",
      name: "dsc_empid",
      element: {
        label: "Employee Id",
        classList:["smart-form-input"],
        placeHolder: "Enter your Employee Id",
        leftIcon:"fa-user",
        validations: validations.dsc_empid,
        inputProps:{ 
          disabledFunction:()=>{
            if(dataIn) return true
          } 
        }
      },
    },
    {
        type: "SELECT_BOX",
        width: "3",
        name: "dsc_type",
        element: {
            classList:["smart-form-input"],
            label: "DSC Type",
            placeHolder: "Select DSC Type",
            validations: validations.dsc_type,
            options: [
                {value: 1, label:'Soft Token'},
                {value: 2, label:'Hard Token'},
            ],
        }
    },
    {
      type: "TEXT_BOX",
      width: "6",
      name: "dsc_empname",
      element: {
        classList:["smart-form-input"],
        label: "Employee Name",
        placeHolder: "Enter your Name",
        inputType:"NORMAL",
        leftIcon:"fa-user",
        validations: validations.dsc_empname,
        inputProps:{ 
          disabledFunction:()=>{
            if(dataIn) return true
          } 
        } 
      },
    },
    {
      type: "BUTTON",
      width: "12",
      name:"",
      class_name: "has-text-right",
      element: {
        label: "Save",
        classList: ["smart-action-button"],
        onClick: handleSave,
      },
    },
];

  const handleInputChange = (name: string, value: string) => {
    setFormData((prev:any) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="sd-pdf-form">  
      <SmartSoftForm
        formData={formData}
        setFormData={handleInputChange}
        elements={formElements}
        />
    </div>
  );
}

export default DscForm;
